import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { PasswordInput } from "react-spark";

import {
  withValidationOutputDefaultProps,
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
  sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";

class URCPasswordInput extends Component {
  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.props.value,
      name: this.props.name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation
    });
  }

  componentDidUpdate() {
    if (this.props.forceUpdate) {
      this.props.context.updateFormElement({
        value: this.props.value,
        name: this.props.name,
        valid: this.props.validateOnRegisterUpdate.apply(this)
      });
    }
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  handleChanges(event) {
    const {handleChange, callback, context} = this.props;
    handleChange(event, context);

    // adding for Confirm Password functionality
    if (callback) {
      callback(event.target.value);
    }
  }

  render() {
    const {
      className,
      context,
      disabled,
      errorMessage,
      handleBlur,
      hideLabel,
      id,
      label,
      name,
      pattern,
      placeholder,
      value,
      width
    } = this.props;
    const patternProp = pattern == null ? {} : { pattern };
    const placeholderProp = placeholder == null ? {} : { placeholder };
    return (
      <PasswordInput
        className={className}
        disabled={disabled}
        error={errorMessage}
        id={id}
        label={hideLabel ? "" : label}
        name={name}
        onChange={event => this.handleChanges(event)}
        onBlur={event => handleBlur(event, context.handleChange)}
        width={width}
        {...patternProp}
        {...placeholderProp}
        value={value}
      />
    );
  }
}

URCPasswordInput.defaultProps = {
  ...withValidationOutputDefaultProps,
  ...sharedFormInputDefaultProps,
  pattern: null,
  value: ""
};

URCPasswordInput.propTypes = {
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes,
  pattern: PropTypes.string,
  value: PropTypes.string.isRequired,
  callback: PropTypes.func
};

export default withValidation(URCPasswordInput);
